import React from 'react'
import { render } from 'react-dom'

import App from './App'

const url = new URL(window.location)


render(<App />, document.querySelector('#root'))
